import React, { Component } from 'react';
import sortBy from 'lodash.sortby';

class TodoTable extends Component {
      render() {
		  return (<div>
		  {this.props.loading && 
              <div style={{"position":"fixed","top": "70%", "left": "50%", "transform": "translate(-50%, -50%)"}} 
                 class="w3-opacity w3-container w3-padding-large w3-center">
                  <div class="w3-text-dark-gray w3-panel w3-light-gray w3-card-4 w3-section">
                    <h2>Loading</h2>
                    <p><i class="fa fa-circle-o-notch w3-spin" style={{"font-size":180}}></i></p>
                  </div>
              </div>
		  }
			  <table class="todotable w3-table w3-bordered w3-hoverable">
				{this.props.todos.length > 0 && <thead><tr class="w3-theme-l3"><th>Date</th><th>Description</th><th></th></tr></thead>}
				<tbody>
				{sortBy(this.props.todos, function(value) {
					const [d, m, y] = value.date.split('.');
					return new Date(y, m - 1, d);
				}).map((item, index) => 
				<tr key={index}>
					<td style={{"width":120}}>{item.date}</td>
					<td style={{"width":"100%"}}>{item.description}</td>
					<td style={{"width":120}}><button class="w3-button w3-red" name={item._id} onClick={this.props.btn}>Remove</button></td>
				</tr>
				)}
				</tbody>
			  </table>
			</div>);
		
	}
}

export default TodoTable;



// WEBPACK FOOTER //
// ./src/TodoTable.js